/*********************************************************
 *                  Admin Reports Ctrl
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("AdminReportsCtrl", ["$scope", "Utils", "entities", "$uibModal", "AdminReportsService", "toastr", function ($scope, Utils, entities, $uibModal, AdminReportsService, toastr) {

		/************************************************************************************************************
             *  SETUP
             *************************************************************************************************************/

		$scope.data = {
			entities: entities.data
		};

		var deleteModal;


		/************************************************************************************************************
             *  $scope functions
             *************************************************************************************************************/


		/************************************************************************************************************
             *  WEB SERVICE DELETE
             *************************************************************************************************************/
		/**
             * Ouvrir la modal de suppression.
             */
		$scope.openDeleteEntityModal = function (entity) {
			$scope.data.entityToDelete = entity;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};


		$scope.deleteEntity = function (id) {
			AdminReportsService.deleteEntity(id)
				.then(() => {
					toastr.success("", "Rapport supprimé");
					AdminReportsService.getAllEntities().then(function (data) {
						$scope.data.entities = data;
					});
					deleteModal.close();
				})
				.catch((response) => {
					toastr.error(response.data.message, "Problème lors de la suppression du rapport");
				});
                
		};


		/************************************************************************************************************
             *  UTILITY FUNCTION
             *************************************************************************************************************/


	}]
	)
;